import Axios, { AxiosRequestTransformer, AxiosResponseTransformer } from 'axios';

import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { LogService } from '@app/services/log.service';
import NProgress from 'nprogress';

const accountService: AccountService = Injector.get(AccountService);
const tokenExpiredHeader = 'token-expired';
const bearer = 'Bearer';
const NetworkError = 'Error: Network Error';

async function requestInterceptor(request: any) {
	const token = accountService.getAccessToken();
	if (token != null) {
		if (!request.headers) {
			request.headers = {};
		}
		request.headers.Authorization = `${bearer} ${token}`;
	}
	return request;
}

async function responseErrorInterceptor(error: any) {
	if (Axios.isCancel(error) || error.toString().includes(NetworkError)) {
		NProgress.done();
		return Promise.reject(error);
	}

	if (error.response.status === 401 && error.response.headers[tokenExpiredHeader] === 'true') {
		const accessToken = accountService.getAccessToken();
		const refreshToken = accountService.getRefreshToken();

		if (accessToken && refreshToken) {
			// Fetch new accessToken and refreshToken
			const tokenResponse = await accountService.refreshToken({
				accessToken,
				refreshToken,
			});
			accountService.modifyAccessToken(tokenResponse.accessToken);
			accountService.modifyRefreshToken(tokenResponse.refreshToken);

			// Make same request that failed with 401 with new accessToken
			const token = accountService.getAccessToken();
			error.config.headers = { Authorization: `${bearer} ${token}` };
			return Axios.request(error.config);
		}
	}
	return Promise.reject(error.response);
}

async function setUpdateProgress() {
	(Axios.defaults.transformRequest as AxiosRequestTransformer[]).push((data, headers) => {
		NProgress.start();
		return data;
	});
}

async function setStopProgress() {
	(Axios.defaults.transformResponse as AxiosResponseTransformer[]).push((data, headers) => {
		NProgress.done();
		return data;
	});
}

function applyAxiosInterceptors() {
	NProgress.configure({
		minimum: 0.3,
		easing: 'ease',
		speed: 800,
		showSpinner: false,
	});
	setUpdateProgress();
	setStopProgress();
	Axios.interceptors.request.use(requestInterceptor, (error) => {
		// Log Request Error except for errors that related to LogService api's requests
		// else app may get into loop.
		if (!LogService.IsRequestToLogServiceApi(error.request.url)) {
			LogService.LogError(`Axios Request Error: ${JSON.stringify(error)}`);
		}
	});
	Axios.interceptors.response.use((response) => response, responseErrorInterceptor);
}

export default applyAxiosInterceptors;



// WEBPACK FOOTER //
// ./src/app.interceptor.ts